import { Configuration } from "@interface48/api";
import Input from "@material-ui/core/Input";
import "cleave.js/dist/addons/cleave-phone.ca.js";
import { CleaveOptions } from "cleave.js/options";
import Cleave from "cleave.js/react";
import React from "react";

const CleaveInputHelper = (props: any) => {
  const { cleaveOptions, inputRef, ...rest } = props;

  return <Cleave htmlRef={inputRef} options={cleaveOptions} {...rest} />;
};

interface CleaveInputProps {
  id: string;
  placeholder?: string;
  value: string | number | null | undefined;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  cleaveOptions: CleaveOptions;
  className?: string;
  getApiConfiguration?: () => Promise<Configuration>;
  processValue?: (value: string | number | undefined | null) => string | number | null | undefined;
  onChange: (value: string | number | undefined | null, id?: string, otherData?: any) => void;
}

interface CleaveInputState {
  value: string | number | undefined | null;
}

export const CleaveInputComponent = class extends React.Component<CleaveInputProps, CleaveInputState> {
  constructor(props: CleaveInputProps) {
    super(props);

    const { value } = this.props;
    this.state = { value };
  }

  public render() {
    const { id, placeholder, startAdornment, endAdornment, className } = this.props;
    const { cleaveOptions } = this.props;
    const { value } = this.state;

    return (
      <Input
        id={id}
        classes={{ input: className }}
        placeholder={placeholder}
        inputComponent={CleaveInputHelper}
        inputProps={{ cleaveOptions, autoComplete: "off" }}
        startAdornment={startAdornment}
        endAdornment={endAdornment}
        value={value != null ? value : ""}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
      />
    );
  }

  public componentDidUpdate(prevProps: CleaveInputProps, prevState: CleaveInputState) {
    const { value: prevValue } = prevProps;
    const { value } = this.props;

    if (prevValue !== value) {
      this.setState({ value });
    }
  }

  public handleChange = (event: any) => {
    const value = event.target.value;

    this.setState((prevState: CleaveInputState) => {
      return { ...prevState, value };
    });
  };

  public handleBlur = (event: any) => {
    const { onChange, processValue } = this.props;
    const { value } = this.state;

    const processedValue = processValue
      ? (processValue(value) as string | undefined | null)
      : typeof value === "string"
      ? value.trim()
      : value;

    onChange(processedValue);
  };
};

export const CleaveInput = CleaveInputComponent;
